import { TeamYear } from "./types";

export const team2025_26: TeamYear = {
  year: "2025-26",
  facultyAdvisors: [
    {
      id: "fac-1",
      name: "Dr. K.S.Tiwari",
      role: "Faculty Coordinator",
      image: "/team/common/tiwari-mam.jpg",
      deptOrBranch: "E&TC Department",
      social: { linkedin: "https://linkedin.com/in/dr-kanchan-s-tiwari-01705171" },
    },
    {
      id: "fac-2",
      name: "Prof. Yogita Ajgar",
      role: "Faculty Coordinator",
      image: "/team/common/yogita-mam.jpg",
      deptOrBranch: "E&TC Department",
      social: { linkedin: "https://linkedin.com/in/yogita-ajgar-847b1071" },
    },
  ],
  founder: [
    {
      id: "founder-1",
      name: "Arnav Botre",
      role: "Founder",
      image: "/team/common/arnav.jpg",
      deptOrBranch: "Alumni - E&TC",
      social: { linkedin: "https://www.linkedin.com/in/arnav-botre-b2a7591b2/", instagram:"https://www.instagram.com/arnav_botre14/", email: "botrearnav@gmail.com" },
    },
  ],
    coreCommittee: [
    {
      id: "core-1",
      name: "Atharva Patil",
      role: "President",
      image: "/team/2025-26/atharva.jpg",
      deptOrBranch: "E&TC Department",
      social: { linkedin: "https://www.linkedin.com/in/atharva-patil-853b25308?", instagram: "https://www.instagram.com/atharvapatil5761?", email: "patilatharva486@gmail.com" },
    },
    {
      id: "core-2",
      name: "Shreya Patil",
      role: "Vice-President",
      image: "/team/2025-26/shreya.jpg",
      deptOrBranch: "E&TC Department",
      social: { linkedin: "https://www.linkedin.com/in/shreya-patil-6711302a6", instagram: "https://www.instagram.com/shreyap1205?", email: "shreyapatil0765@gmail.com" },
    },
    {
      id: "core-3",
      name: "Srushti Gulave",
      role: "Treasurer",
      image: "/team/2025-26/srushti.jpg",
      deptOrBranch: "E&TC Department",
      social: { linkedin: "https://www.linkedin.com/in/srushti-gulave-16b8002b3", instagram: "https://www.instagram.com/srushtii. 10?", email: "srushtigulave10@gmail.com" },
    },
    {
      id: "core-4",
      name: "Vikrant Pardeshi",
      role: "Project Head",
      image: "/team/2025-26/vikrant.jpg",
      deptOrBranch: "E&TC Department",
      social: { linkedin: "https://www.linkedin.com/in/vikrant-pardeshi-a29488327?", instagram: "https://www.instagram.com/_vikrant_pardeshi_? ", email: "vikrantpardeshi2005@gmail.com" },
    },
    {
      id: "core-5",
      name: "Siya lokhande",
      role: "Publicity & Marketing Head",
      image: "/team/2025-26/siya.jpg",
      deptOrBranch: "E&TC Department",
      social: { linkedin: "https://www.linkedin.com/in/siya-lokhande-72b02432a", instagram: "https://www.instagram.com/_.siya_._?", email: "Siyalokhande2006@gmail.com" },
    },
    {
      id: "core-6",
      name: "Soham Bhalgat",
      role: "Documentation Head",
      image: "/team/2025-26/soham.jpg",
      deptOrBranch: "E&TC Department",
      social: { linkedin: "https://www.linkedin.com/in/soham-bhalgat-0ab401311", instagram: "https://www.instagram.com/soham_bhalgat?", email: "sohambhalgat24@gmail.com" },
    },
    
    {
      id: "core-7",
      name: "Atharav Kale",
      role: "Social Media Head",
      image: "/team/2025-26/atharav.jpg",
      deptOrBranch: "E&TC Department",
      social: { linkedin: "https://www.linkedin.com/in/atharav-k-218805328?", instagram: "https://www.instagram.com/atharavvv_?", email: "athk30072005@gmail.com" },
    },
    {
      id: "core-8",
      name: "Vaibhavi Gaikwad",
      role: "Social Media Head",
      image: "/team/2025-26/vaibhavi.jpg",
      deptOrBranch: "Computer Department",
      social: { linkedin: "https://www.linkedin.com/in/vaibhavi-gaikwad-917203331?", instagram: "https://www.instagram.com/whoisvaibhavi ?", email: "vaibhavig004@gmail.com" },
    },
    {
      id: "core-9",
      name: "Sanskruti Chothe",
      role: "Event Head",
      image: "/team/2025-26/sanskruti.jpg",
      deptOrBranch: "E&TC Department",
      social: { linkedin: "https://www.linkedin.com/in/sanskruti-chothe-b9b860368", instagram: "https://www.instagram.com/c.sanskruti_07?", email: "chothesanskruti@gmail.com" },
    },
    {
      id: "core-10",
      name: "Shubham Devkar",
      role: "Graphics Designer",
      image: "/team/2025-26/shubham.jpg",
      deptOrBranch: "Mechanical Department",
      social: { linkedin: "https://www.linkedin.com/in/shubham-devkar-a576aa328?", instagram: "https://www.instagram.com/shubham_devkar77?", email: "shubhamdevkar530@gmail.com" },
    },
    {
      id: "core-11",
      name: "Gaytri Hande",
      role: "Web Developer",
      image: "/team/2025-26/gaytri.jpg",
      deptOrBranch: "Computer Department",
      social: { linkedin: "https://www.linkedin.com/in/gaytri-hande-969992328?", instagram: "https://www.instagram.com/gaytri.h1506?", email: "handegaytri1@gmail.com" },
    },
    {
      id: "core-12",
      name: "Parth Shinde",
      role: "Student Co-ordinator",
      image: "/team/2025-26/parth.jpg",
      deptOrBranch: "E&TC Department",
      social: { linkedin: "https://www.linkedin.com/in/parth-shinde-0678a4348?", instagram: "https://www.instagram.com/parthshinde330", email: "parthshinde5656@gmail.com" },
    },
    
  ],
};